import React from 'react';
import { Table, Button, Input, Card, Modal, message, Col, Select, Popover, Divider, Form, Popconfirm} from 'antd';
import common from '../../assets/common.js';
import moment from 'moment';
import MenuAction from '../../modest/menuaction/index.js'
import './index.css';
const Option = Select.Option;

const FormItem = Form.Item;
const defaultDate = [moment().startOf('day'),moment().endOf('day')];
class ContactsTable extends React.Component {
  delete = (record) => {
    var postData = {};
    postData["_url"] = "";
    postData["_method"] = "DELETE";
    postData["id"] = record.id;
    common.request(postData, this, function(obj, result){
      const pagination = obj.state.table.pagination;
      obj.getList(pagination);
    });
  }
  cancel = (id) =>{
    console.log(id)
  }
  constructor(){
    super();
    let table = {};
    table.id = "proTable";
    table = common.getDefaultTable(table);
    this.state = {
      table,
      visible: false,
      passWDInfo: {
        realName: "",
        code: ""
      },
      key: "",
      value: "",
      visibleContacts: false,
      info: {
        realName: "",
        deptName: ""
      },
      time: new Date().getTime(),
      visibleArea: false,
      area: [],
      title: ""
    }
  }
  componentWillMount(){
    let this_ = this;
    this.showTableCol();
  }
  componentDidMount(){
    // this.getArea();
    this.getList();
  }
  showTableCol = () => {
    let table = this.state.table;
    table.columnsList = [{
      title: '姓名',
      dataIndex: 'realName',
      must: true,
      show: true,
      width: '80px'
    }, {
      title: '部门',
      dataIndex: 'deptName',
      must: true,
      show: true,
      width : "120px"
    }, {
      title: '微信绑定状态',
      dataIndex: 'status',
      must: true,
      show: true,
      width : "130px",
      render: (text, record) => {
        return (
          <span>{record.status === "UNBIND"?"未绑定":"已绑定"}</span>
        )
      }
    }, {
      title: '操作',
      dataIndex: 'doorName',
      must: true,
      show: true,
      width : "120px",
      render: (text, record) => {
        return (
          <div>
            <a className="a-theme" onClick={() => this.checkWxCode(record)}>绑定码</a>
            <Divider type="vertical"/>
            <a className="a-theme" onClick={() => this.alarmArea(record)}>负责区域</a>
            <Divider type="vertical"/>
            <Popconfirm title="确定要删除联系人吗？" okText="是" cancelText="否" onConfirm={() => this.deletePeople(record)}>
              <a className="a-theme">删除</a>
            </Popconfirm>
            <Divider type="vertical"/>
            {record.status !== "UNBIND" && <Popconfirm title="确定要解绑联系人吗？" okText="是" cancelText="否" onConfirm={() => this.unBindPeople(record)}>
              <a className="a-theme">解绑</a>
            </Popconfirm>}
            {record.status === "UNBIND" && <a className="a-theme" disabled>解绑</a>}
          </div>
        )
      }
    }];
    table = common.getEcardTable(table);
    // console.log(table);
    this.setState({ table });
  }
  alarmArea = async(record) => {
    var postData = {};
    postData["_url"] = "api/alarm/user/rooms";
    postData["_method"] = "GET";
    postData["id"] = record.alarmUserId;
    common.request(postData, this, function(obj, data){
      obj.setState({
        area: data.result,
        visibleArea: true,
        title: record.realName
      })
    },function(obj, state){
      message.warning(state.message);
    });
  }
  deletePeople = async(record) => {
    var postData = {};
    postData["_url"] = "api/alarm/user";
    postData["_method"] = "DELETE";
    postData["id"] = record.alarmUserId;
    common.request(postData, this, function(obj, data){
      const pagination = obj.state.table.pagination;
      obj.getList(pagination.current);
      message.success("删除成功");
    },function(obj, state){
      message.warning(state.message);
    });
  }
  unBindPeople = async(record) => {
    var postData = {};
    postData["_url"] = "api/alarm/user/unbind";
    postData["_method"] = "GET";
    postData["id"] = record.alarmUserId;
    common.request(postData, this, function(obj, data){
      const pagination = obj.state.table.pagination;
      obj.getList(pagination.current);
      message.success("解绑成功");
    },function(obj, state){
      message.warning(state.message);
    });
  }
  changePage = (pagination, filters, sorter) => {
    const table = this.state.table;
    table.pagination = pagination;
    this.setState({ table })
    this.getList(pagination.current)
  }
  thisOk = () => {
    this.getList();
  }
  getList = (pageInfo, filters, sorter) =>{
    var this_ = this;
    const pn = pageInfo ? pageInfo: 1;
    const table = this.state.table;
    var postData = {};
    postData["_url"] = "api/alarm/user/search";
    postData["pageNum"] = pn;

    if(this.state.realName !== "") {
      postData["realName"] = this.state.realName;
    }
    table.loading = true;
    this.setState({ table });
    common.request(postData, this, function(obj, data){
      const result = data.result;
      obj.showList(result, pn);
    },function(obj, state){
      table.loading = false;
      obj.setState({ table });
    });
  }
  showList = (result, pn) => {
    const table = this.state.table;
    const list = result.list;
    table.loading = false;
    var dataSource = [];
    table.pagination = {
      current : pn,
      total : result.pageInfo.resultAmount,
    }
    common.eachObj(list, function(index, dataItem){
      var one = dataItem;
      one["key"] = (index + 1);
      one["orgId"] = dataItem.orgId;
      one["orgName"]= dataItem.orgName;
      one["userName"] = dataItem.userName;
      dataSource.push(one);
    })
    table.dataSource = dataSource;
    this.setState({ table });
  }
  handleCancel = ()=> {
    this.setState({
      visible: false
    });
  }
  handleCancelArea = ()=> {
    this.setState({
      visibleArea: false
    });
  }
  checkWxCode = (record) => {
    var postData = {};
    postData["_url"] = "api/alarm/user/code";
    postData["_method"] = "GET";
    postData["id"] = record.alarmUserId;
    common.request(postData, this, function(obj, data){
      const result = data.result;
      obj.setState({
        visible: true,
        passWDInfo: {
          realName: record.realName,
          code: result
        }
      });
    },function(obj, state){
      message.warning(state.message);
    });

  }
  handleCancelContacts = () => {
    this.setState({
      visibleContacts: false
    });
  }
  setRealName = (e) => {
    this.setState({
      realName: e.target.value
    })
  }
  showContacts = () => {
    this.setState({
      visibleContacts: true
    })
  }
  addContacts = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.submit(values);
      }
    })

  }
  submit = async(values) => {
    var postData = values;
    postData["_url"] = "api/alarm/user";
    common.request(postData, this, function(obj, data){
      const result = data.result;
      obj.setState({
        visibleContacts: false
      })
      const pagination = obj.state.table.pagination;
      obj.getList(pagination.current);
      message.success("添加成功");
    },function(obj, state){
    });
  }
  render(){
    const { table, passWDInfo, visibleContacts, info, time, visibleArea, area, title} = this.state;
    // const pswtitle = "请用支付宝扫码查看"+ this.state.orgName +"的密码";
    const qrcode = "api/alarm/user/bind/qrcode?v=" + time;
    const formItemLayout = {
        labelCol: { span: 5 },
        wrapperCol: { span: 18 },
    };
    const { getFieldDecorator } = this.props.form;
    return(
      <Card>
        <div>
          <div className="table-menu">

            <div className="clearfix">
              <Col span={16}>
                <label>姓&emsp;名：</label>
                <Input style={{width:200}} placeholder="请输入姓名" value={ this.state.realName } onChange={ this.setRealName }/>
                <Button type="primary" style={{marginLeft: 15}} onClick={ this.thisOk }>查询</Button>
              </Col>
              <Col span={8}>
                <Button type="primary" onClick={this.showContacts}>新增报警联系人</Button>
                <div className="pull-right">
                  { table.show && <MenuAction obj={ this }/> }
                </div>
              </Col>
            </div>
          </div>
          <div id="manageTableDiv" className="table-div clearfix">
            { table.show && <Table
              { ...table }
              onChange={this.changePage.bind(this)}
            />}
            <div className="table-total">共{ table.pagination.total }条数据</div>
          </div>
          <div className="clearfix">
            <div className="pull-left">
              <div style={{marginRight: 15,color: "#F52E38"}}>搜索微信号"iyunban"或"云瓣校园"关注公众号接收消息，联系人微信扫码绑定:</div>
            </div>
            <div className="pull-left">
              <div style={{textAlign: "left",marginBottom: 15}}><img className="qrcode" src={qrcode} alt="绑定图片"/></div>
            </div>
          </div>
          <Modal
            title="查看绑定码"
            visible={this.state.visible}
            centered={true}
            className="text-center"
            onCancel={this.handleCancel}
            footer={[
              <Button onClick={this.handleCancel}>关闭</Button>
            ]}
          >
            <div style={{textAlign: 'center'}} >
              <div style={{textAlign: "left"}}>
                <div style={{marginBottom: 10}}>联系人：{passWDInfo.realName}</div>
                <div>微信绑定码：{passWDInfo.code}</div>
              </div>
            </div>
          </Modal>
          <Modal
            title="添加报警联系人"
            visible={visibleContacts}
            onCancel={this.handleCancelContacts}
            footer={[
              <Button type="primary" onClick={this.addContacts}>添加</Button>,
              <Button onClick={this.handleCancelContacts}>关闭</Button>
            ]}
          >
            <Form>
              <FormItem {...formItemLayout}
                  label={"姓名"}>
                  {getFieldDecorator('realName', {
                      rules: [{
                          required: true, message: '请填写报警联系人姓名',
                      }],
                      initialValue: info.realName
                  })(
                      <Input />
                  )}
              </FormItem>
              <FormItem {...formItemLayout}
                  label={"部门"}>
                  {getFieldDecorator('deptName', {
                      rules: [{
                          required: true, message: '请填写报警联系人部门',
                      }],
                      initialValue: info.deptName
                  })(
                      <Input />
                  )}
              </FormItem>
            </Form>
          </Modal>
          <Modal
            title="查看负责区域"
            visible={visibleArea}
            centered={true}
            className="text-center"
            onCancel={this.handleCancelArea}
            footer={[
              <Button onClick={this.handleCancelArea}>关闭</Button>
            ]}
          >
            <div style={{textAlign: 'left'}} >
              <div style={{marginBottom: 10}}>联系人：{title}</div>
              <div>负责区域：</div>
              <div style={{textAlign: "left"}}>
                { area.length > 0 && area.map((item) => {
                  return <div>{item.name}</div>
                })}
              </div>
            </div>
          </Modal>
        </div>
      </Card>
    )
  }
}
const ContactsTableForm = Form.create()(ContactsTable);
export default ContactsTableForm;



// WEBPACK FOOTER //
// ./src/component/devicealarm/alarmcontacts.js